import { Typography } from '../primitives/index.js'
import type { FC } from 'react'
import { graphHooks } from '@tunasong/graph-lib/react'
import { UserAvatar } from './user-avatar.js'

export interface ProfileCardProps {
  userId: string
}

export const ProfileCard: FC<ProfileCardProps> = props => {
  const { userId } = props
  const { profile: user } = graphHooks.useProfile(userId)
  const title = user?.name ?? user?.email
  const subheader = user?.name ? user?.email : ''
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 16, padding: 16 }}>
      <UserAvatar userId={userId} style={{ alignItems: 'normal' }} />
      <div>
        <Typography variant="subtitle1">{title}</Typography>
        {subheader ? <Typography variant="body2" color="textSecondary">{subheader}</Typography> : null}
      </div>
    </div>
  )
}
export default ProfileCard
